module.exports = __webpack_public_path__ + "static/img/fullscreen-image_background_768.9e75e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact-us/fullscreen-image_background_768.png
// module id = lXmE
// module chunks = 0